module.exports = __webpack_public_path__ + "media/6.2dbb3f71.wav";